<script lang="ts">
	import lightbulb from '$lib/assets/events/lightbulb.svg';
	import StrapiContent from './StrapiContent.svelte';

	interface Props {
		title: string;
		description: string;
		primaryActionLabel: string;
		primaryActionUrl: string;
	}

	let { title, description, primaryActionLabel, primaryActionUrl }: Props = $props();
</script>

<section
	class="section-mb border-green-primary mx-auto flex max-w-screen-md flex-col items-center rounded-2xl border-2 p-5 text-center"
>
	<img src={lightbulb} alt="lightbulb" class="mb-3 h-8 w-8" />
	<header class="h1-serif mb-3 flex items-start justify-center gap-2">
		{title}
	</header>
	<StrapiContent content={description} class="mb-5" />
	<a href={primaryActionUrl} class="btn btn-primary w-72">{primaryActionLabel}</a>
</section>
